/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:899f84db-07e4-4206-b37b-93a77a8f75ef",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_3qFnPtBMU",
    "aws_user_pools_web_client_id": "1jb618tkfc4omj63f67j44ted2",
    "oauth": {
        "domain": "amplifycongitoauth-axa-it.auth.eu-central-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_appsync_graphqlEndpoint": "https://gdftbk6tivhg7k6bhskrryivai.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AWS_LAMBDA",
    "aws_cloud_logic_custom": [
        {
            "name": "GetProductsRestAPI",
            "endpoint": "https://g2kvb2wfa1.execute-api.eu-central-1.amazonaws.com/master",
            "region": "eu-central-1"
        }
    ],
    "aws_content_delivery_bucket": "awsdrtool-hostingbucket-722818841205-eu-central-1-master",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "https://d22bvg9xwxd995.cloudfront.net"
};


export default awsmobile;
